
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import { getToken, IsModemAccess } from '../../../helpers/Helper';
import { del, post } from '../../../helpers/api_helper';
import { POST_CHEQUE_FORMAT_LIST, DELETE_CHEQUE_FORMAT, POST_UPDATE_CHEQUE_FORMAT_STATUS } from '../../../helpers/url_helper';
import { toast } from 'react-toastify';
import ReactDOM from 'react-dom/client';
import useMounted from '../../../hooks/useMounted';

import $ from 'jquery';
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/dataTables.dataTables.css";


const UserRoles = (props) => {
    const navigate = useNavigate();
    const [formatId, SetFormatId] = useState(0);


    useMounted(() => {
        getList()
    })

    const getList = () => {
        const tableElement = $('#dataTableExample');
        if (tableElement.length > 0) {
            tableElement.DataTable({
                destroy: true,
                "bProcessing": true,
                "bServerSide": true,
                'searching': true,
                'stateSave': true,
                "scrollX": false,
                "sServerMethod": "POST",
                "order": [[0, 'desc']],
                columnDefs: [
                    { orderable: false, targets: [3,4] },
                    { "targets": 0, "visible": false }
                ],
                "ajax": function (data, callback, settings) {
                    data.sSearch = data.search.value;
                    data.iDisplayLength = data.length;
                    data.iDisplayStart = data.start;
                    data.sSortDir_0 = (data.order.length > 0) ? data.order[0].dir : '';
                    data.iSortCol_0 = (data.order.length > 0) ? data.order[0].column : '';

                    $.ajax({
                        "url": POST_CHEQUE_FORMAT_LIST,
                        "type": "POST",
                        "data": data,
                        "headers": { 'Authorization': getToken() },
                        "error": function (xhr, status, error) {
                            if (xhr.status === 401) {
                                navigate("/logout");
                            }
                        },
                        "success": callback
                    });
                },
                "columns": [
                    { "data": "formatId" },
                    { "data": "bankName" },
                    { "data": "formatName" },
                    {
                        "data": null, 'createdCell': (td, data) => {
                            const root = ReactDOM.createRoot(td);
                            root.render(<>
                                <button onClick={UpdateStatus.bind(this, data.formatId, data.formatStatus)} className={`border-0 badge ${(data.formatStatus === 'Active') ? 'bg-success' : 'bg-danger'}`}>{data.formatStatus}</button>
                            </>)
                        }
                    },
                    {
                        "data": null, 'createdCell': (td, data) => {
                            const root = ReactDOM.createRoot(td);
                            root.render(<>
                                {IsModemAccess('cheque_format', 'edit') && <> <button className="btn btn-sm text-primary mr-2" onClick={() => { navigate('/admin/cheque-formates/edit/' + data.formatId); }} ><i className="bx bx-edit"></i></button> </>}

                                {IsModemAccess('cheque_format', 'delete') && <button className="btn btn-sm text-danger" onClick={() => { SetFormatId(data.formatId); }} data-bs-toggle="modal" data-bs-target="#deleteModal" ><i className="bx bx-trash-alt align-middle"></i></button>}
                            </>)
                        }
                    },
                ]
            });
        }
    }

    //UpdateStatus
    const UpdateStatus = async (formatId, status) => {
        if (!IsModemAccess('cheque_format', 'edit')) {
            toast.error('Does not permission this module');
            return;
        }
        var res_data = await post(POST_UPDATE_CHEQUE_FORMAT_STATUS, { formatId: formatId, status: status });
        if (res_data.status) {
            toast(res_data.message);
            getList();
        } else {
            toast.error(res_data.message);
        }
    }

    // remove user role
    const remove_row = async () => {
        var res_data = await del(DELETE_CHEQUE_FORMAT + "?formatId=" + formatId);
        if (res_data.status) {
            toast(res_data.message);
            getList();
        } else {
            toast.error(res_data.message);
        }
    }

    return (
        <>
            <div className='row'>
                <div className="col-12 col-sm-12 col-md-12 col-lg-8 mb-4">
                    <div className="card">
                        <div className="card-body">
                            <div className='row mb-3'>
                                <div className='col-sm-6'>
                                    <h5 className='mt-1'>Cheque Formates</h5>
                                </div>
                                <div className='col-sm-6 text-right'>
                                    {IsModemAccess('cheque_format', 'add') && <Link to='/admin/cheque-formates/add' className='btn btn-sm btn-primary'>+ Add</Link>}
                                </div>
                            </div>
                            <hr />
                            <div className='table-responsive text-nowrap'>
                                {IsModemAccess('cheque_format', 'view') &&
                                    <table id="dataTableExample" className="table table-striped">
                                        <thead>
                                            <tr>
                                                <td>Id</td>
                                                <td>Bank Name</td>
                                                <td>Format Name</td>
                                                <td>Status</td>
                                                <td>Action</td>
                                            </tr>
                                        </thead>
                                    </table>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal fade" id="deleteModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">Confirm Delete</h5>
                            <button type="button" className="btn btn-sm close" data-bs-dismiss="modal" aria-label="Close">
                                <i className="bx bx-x"></i>
                            </button>
                        </div>
                        <div className="modal-body">
                            <p>Are you sure you want to delete this record?</p>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">No</button>
                            <button onClick={remove_row.bind(this)} data-bs-dismiss="modal" className="btn btn-primary">Yes</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default UserRoles;